import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-bl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-bl.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { ViewApplicationDetailsItamsConstants } from "../../it/view-application-details-itams/view-application-details-itams.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationDetailsBlConstants } from "./view-application-details-bl.constants";
import { AlertType } from "../../../../shared/models/alert";
import { take } from "rxjs/operators";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
let ViewApplicationDetailsBlComponent = class ViewApplicationDetailsBlComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    recipientService;
    appControllerService;
    changeDetectorRef;
    routerParamsService;
    detailsForm;
    validationMessages = ViewApplicationDetailsBlConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = ViewApplicationDetailsBlConstants.DESCRIPTION_FORM_CONTROL_NAME;
    typeFormControlName = ViewApplicationDetailsBlConstants.TYPE_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    descriptionLabel = ViewApplicationDetailsBlConstants.DESCRIPTION_LABEL;
    typeLabel = ViewApplicationDetailsBlConstants.TYPE_LABEL;
    tradeNameLabel = ViewApplicationDetailsBlConstants.TRADE_NAME_LABEL;
    tradeNameFormControlName = ViewApplicationDetailsBlConstants.TRADE_NAME_CONTROL;
    businessOwnerLabel = ViewApplicationDetailsBlConstants.BUSINESS_OWNER_LABEL;
    businessOwnerFormControlName = ViewApplicationDetailsBlConstants.BUSINESS_OWNER_CONTROL;
    businessOwnerHeading = ViewApplicationDetailsBlConstants.BUSINESS_OWNER_HEADING;
    businessOwnerDisableFilterBy = true;
    businessOwnerDisableEditing = false;
    businessOwnerGroups = [];
    applicationTypes = [];
    selectedApplicationSubscription;
    getLookupsObservableSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, recipientService, appControllerService, changeDetectorRef, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.recipientService = recipientService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.routerParamsService = routerParamsService;
        this.listenForRouteParamChange();
    }
    ngOnInit() {
        this.initForm();
        this.getLookups();
    }
    loadMetadata(stepMeta) {
        try {
            this.businessOwnerGroups = stepMeta.businessOwnerGroup;
            this.changeDetectorRef.detectChanges();
        }
        catch (e) {
            this.appControllerService.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    handleRouteChange() {
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(ViewApplicationDetailsBlConstants.DETAILS_FORM_GROUP_NAME);
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and deleted eq false`,
        };
        this.getLookupsObservableSubscription = this.applicationViewService
            .getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsItamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.trim().toLowerCase() === `${ViewApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    applicationTypes.push(JSON.parse(item.content));
                }
            });
            this.applicationTypes = applicationTypes;
            this.changeDetectorRef.markForCheck();
            this.subscribeToSelectedApplication();
        }
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.descriptionFormControlName).disable();
        this.detailsForm.get(this.typeFormControlName).setValue(application.type);
        this.detailsForm.get(this.typeFormControlName).disable();
        this.detailsForm.get(this.tradeNameFormControlName).setValue(application.tradeName);
        this.detailsForm.get(this.tradeNameFormControlName).disable();
        this.getBusinessOwnerByApplicantId(application.businessOwnerId);
    }
    ngAfterViewInit() {
    }
    getBusinessOwnerByApplicantId(businessOwnerId) {
        const params = {
            $expand: "groups",
            $filter: `id eq ${businessOwnerId} and deleted eq false`
        };
        this.recipientService.getRecipientsObservable(params).pipe(take(1)).subscribe({
            next: (recipients) => {
                if (recipients.length > 0) {
                    const savedBusinessOwner = recipients[0];
                    this.detailsForm.get(this.businessOwnerFormControlName).setValue(savedBusinessOwner);
                    this.detailsForm.get(this.businessOwnerFormControlName).disable();
                }
                else {
                    this.detailsForm.get(this.businessOwnerFormControlName).disable();
                }
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage("business owner", error, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: RecipientService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsBlComponent = __decorate([
    Component({
        selector: "app-view-application-details-bl",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsBlComponent);
export { ViewApplicationDetailsBlComponent };
